module.exports = __webpack_public_path__ + "static/SafeBrowsing_Logo_Vert_960-b19edb2b5fe75667eb32535a345e7d6d.png";